@import 'styles/mixins';
@import 'styles/variables';

.actionLabel {
  @include line-clamp;
}
